import Vue from 'vue'

import RbCountdown from '@/elements/countdown/rb-countdown.lazy.vue'
Vue.component('rb-countdown', RbCountdown)

import RbAnchor from '@/elements/anchors/anchor.lazy.vue'
Vue.component('rb-anchor', RbAnchor)

import RbAnchorsBar from '@/elements/anchors-bar/anchors-bar.lazy.vue'
Vue.component('rb-anchors-bar', RbAnchorsBar)

import RbStoriesSlider from '@/elements/stories-slider/stories-slider.vue'
Vue.component('rb-stories-slider', RbStoriesSlider)

import VideoButton from '@/elements/editorial/video/video-button.vue'
Vue.component('video-button', VideoButton)

import VideoBackground from '@/elements/editorial/video/video-background.vue'
Vue.component('video-background', VideoBackground)

import RbEditorialProductTile from '@/elements/editorial/editorial-product-tile/rb-editorial-product-tile.vue'
Vue.component('rb-editorial-product-tile', RbEditorialProductTile)

const RbStepsStepper = () =>
  import(/* webpackChunkName: "editorial-chunk" */ '@/elements/steps-stepper/steps-stepper.vue')
Vue.component('rb-steps-stepper', RbStepsStepper)

import RbBenefitsPolarizedLenses from '@/elements/editorial/cms-layout-variants-wrappers/rb-benefits-polarized-lenses/rb-benefits-polarized-lenses.vue'
Vue.component('rb-benefits-polarized-lenses', RbBenefitsPolarizedLenses)

import RbPill from '@/elements/pill/pill.vue'
Vue.component('rb-pill', RbPill)

import RbLabel from '@/elements/label/label.vue'
Vue.component('rb-label', RbLabel)

import RbMessageBox from '@/elements/message-box/message-box.vue'
Vue.component('rb-message-box', RbMessageBox)

import DashButton from '@/elements/dash-button/dash-button.vue'
Vue.component('rb-dash-button', DashButton)

import DashButtonBar from '@/elements/dash-button-bar/dash-button-bar.vue'
Vue.component('rb-dash-button-bar', DashButtonBar)

import RbFaqModule from '@/elements/editorial/faq/rb-faq-module.vue'
Vue.component('rb-faq-module', RbFaqModule)

import RbFaqAccordion from '@/elements/editorial/faq/rb-faq-accordion.vue'
Vue.component('rb-faq-accordion', RbFaqAccordion)

import RbSeoFrameAdvisorFaq from '@/elements/seo/rb-seo-frame-advisor-faq.vue'
Vue.component('rb-seo-frame-advisor-faq', RbSeoFrameAdvisorFaq)

const RbCmsRegistrationModule1 = () =>
  import('@/elements/cms-registration-form/cms-registration-module-1.lazy.vue')
Vue.component('rb-cms-registration-module-1', RbCmsRegistrationModule1)

const RbCmsRegistrationModule2 = () =>
  import('@/elements/cms-registration-form/cms-registration-module-2.lazy.vue')
Vue.component('rb-cms-registration-module-2', RbCmsRegistrationModule2)

const RbCmsRegistrationModule3 = () =>
  import('@/elements/cms-registration-form/cms-registration-module-3.lazy.vue')
Vue.component('rb-cms-registration-module-3', RbCmsRegistrationModule3)

const RbCmsRegistrationModule4 = () =>
  import('@/elements/cms-registration-form/cms-registration-module-4.lazy.vue')
Vue.component('rb-cms-registration-module-4', RbCmsRegistrationModule4)

const RbCmsRegistrationModule5 = () =>
  import('@/elements/cms-registration-form/cms-registration-module-5.lazy.vue')
Vue.component('rb-cms-registration-module-5', RbCmsRegistrationModule5)

const RbCmsRegistrationModule6 = () =>
  import('@/elements/cms-registration-form/cms-registration-module-6.lazy.vue')
Vue.component('rb-cms-registration-module-6', RbCmsRegistrationModule6)

const RbCmsRegistrationModule7 = () =>
  import('@/elements/cms-registration-form/cms-registration-module-7.lazy.vue')
Vue.component('rb-cms-registration-module-7', RbCmsRegistrationModule7)

const RbCmsRegistrationModule8 = () =>
  import('@/elements/cms-registration-form/cms-registration-module-8.lazy.vue')
Vue.component('rb-cms-registration-module-8', RbCmsRegistrationModule8)

const RbCmsRegistrationFormFacebookWrapper = () =>
  import('@/elements/cms-registration-form/cms-registration-form-facebook-wrapper.lazy.vue')
Vue.component('rb-cms-registration-form-facebook-wrapper', RbCmsRegistrationFormFacebookWrapper)

// TODO: Move this inside registration form
const RbCmsRegistrationFormThankYouPage = () =>
  import('@/elements/cms-registration-form/cms-registration-form-thank-you-page.lazy.vue')
Vue.component('rb-cms-registration-form-thank-you-page', RbCmsRegistrationFormThankYouPage)

// TODO: Move this inside registration form
const RbCmsRegistrationFormError = () =>
  import('@/elements/cms-registration-form/cms-registration-form-error.lazy.vue')
Vue.component('rb-cms-registration-form-error', RbCmsRegistrationFormError)

import RbAlgoliaEditorialProducts from '@/elements/editorial/algolia/rb-algolia-editorial-products.vue'
Vue.component('rb-algolia-editorial-products', RbAlgoliaEditorialProducts)

import RbAlgoliaFeaturedProducts from '@/elements/editorial/algolia/rb-algolia-featured-products.vue'
Vue.component('rb-algolia-featured-products', RbAlgoliaFeaturedProducts)

import RbAlgoliaTrendingItems from '@/elements/editorial/algolia/rb-algolia-trending-items.vue'
Vue.component('rb-algolia-trending-items', RbAlgoliaTrendingItems)

import RbUsefulLink from '@/elements/header/search/rb-useful-link.vue'
Vue.component('rb-useful-link', RbUsefulLink)

import RbAlgoliaPopularSearches from '@/elements/header/search/rb-algolia-popular-searches.vue'
Vue.component('rb-algolia-popular-searches', RbAlgoliaPopularSearches)
